import React from 'react';

function MaintenancePage() {
    return (
        <>
            <div
                style={{
                    position: "absolute",
                    left: "30%",
                    top: "30%",
                    fontSize: "22px",
                }}
            >
                The site is under maintenance. It will be available in some
                minutes.
            </div>
            <img
                src="/assets/images/maintenance.png"
                alt="Site under maintenance"
                width="90%"
                height="90%"
                style={{ padding: 0, margin: 0 }}
            />
        </>
    );
}

export default MaintenancePage;
